module.exports = __webpack_public_path__ + "static/media/uploadNewDeviceTemplate.1b931f91.xlsx";


//////////////////
// WEBPACK FOOTER
// ./src/downloads/uploadNewDeviceTemplate.xlsx
// module id = 2294
// module chunks = 0